import React from 'react';
import { TIconProps } from 'pages/ExperienceCanvas/assets/types';

function QueueRingIcon({ fill = '#cdd0d7', className = '', ariaHidden = true }: TIconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      focusable={false}
    >
      <circle cx="8" cy="8" r="5.4" stroke={fill} strokeWidth="1.6" fill="none" />
    </svg>
  );
}

export default QueueRingIcon;
